import React from 'react';
import { GuuruFilled } from '@guuru/react-icon';
import Logo from './Logo';

interface LoadingViewProps {
  loadingMessage?: string;
  motion?: boolean;
}

const LoadingView = function ({
  loadingMessage = '',
  motion = true,
}: LoadingViewProps) {
  return (
    <Logo $motion={motion}>
      <GuuruFilled style={{ fontSize: 78 }} />
      <h2>{loadingMessage}</h2>
    </Logo>
  );
};

export default LoadingView;
